module.exports = __webpack_public_path__ + "MDArsalaan-340378bb.webp";